<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <!--          <CCardHeader>-->
                    <!--            <CRow>-->
                    <!--              <CCol>-->
                    <!--                <strong>{{$t('inventoryNeed')}}</strong>-->
                    <!--              </CCol>-->
                    <!--              <CCol  style="text-align: end;">-->
                    <!--                &lt;!&ndash;                <CButton @click="AddAllRefer()" size="sm" color="primary">&ndash;&gt;-->
                    <!--                &lt;!&ndash;                  {{ $t('components.referSelected') }}&ndash;&gt;-->
                    <!--                &lt;!&ndash;                </CButton>&ndash;&gt;-->
                    <!--              </CCol>-->

                    <!--            </CRow>-->

                    <!--          </CCardHeader>-->
                    <CCardBody>
                        <CRow style="text-align: end">

                            <CCol col="9">
                            </CCol>
                            <CCol col="3">
                                <CButton @click="insert_data()" type="submit" size="sm" color="secondary">
                                    {{$t('Submit')}}
                                </CButton>
                            </CCol>
                        </CRow>

                        <CDataTable
                                :items="request_product_items"
                                :fields="request_product_fields"
                                striped
                                border
                                :items-per-page="200"
                                hover
                                pagination
                        >


                            <template #row="{item,index}">
                                <td>
                                    <p style="text-align: center">{{ index+1 }}</p>
                                </td>
                            </template>


                            <template #productCode="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.productCode }}</p>
                                </td>
                            </template>
                            <template #salesProgram="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.salesProgram }}</p>
                                </td>
                            </template>
                            <template #minQty="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.minQty }}</p>
                                </td>
                            </template>
                            <template #stock="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.stock }}</p>
                                </td>
                            </template>
                            <template #onTheWay="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.onTheWay }}</p>
                                </td>
                            </template>
                            <template #reqQty="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.reqQty }}</p>
                                </td>
                            </template>


                            <template #SystemRequest="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.SystemRequest }}</p>
                                </td>
                            </template>
                            <template #SystemRequestInput="{item,index}">
                                <td>
                                    <CInput :disabled="item.SystemRequest<=0"
                                            v-model="request_product_items[index].SystemRequestInput"/>
                                </td>
                            </template>
                            <template #select-header="{item}">
                                <input type="checkbox" v-model="check_all_exit"
                                />
                            </template>
                            <template #select="{item}">
                                <td>
                                    <input v-if="item.SystemRequest>0" type="checkbox" ref="permissions[]"
                                           v-model="id_checkbox_items"
                                           :value="item.productId"/>
                                </td>
                            </template>
                        </CDataTable>

                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>


    </div>

</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'
    import Vue from "vue";

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                // show_document: 'test-dynamic',
                printed_doc_id: 0,
                name: '',
                show_factor_detail: false,
                check_all_exit: false,

                start_date: '',
                end_date: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                id_checkbox_items: [],
                item_sell_array: [],
                items_buy: [],
                selected_factor: [],
                selected_master: {},
                request_product_items: [],
                request_product_fields: [
                    {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
                    {key: 'productCode', label: this.$t('components.productCode'), _style: 'width:10%'},

                    {key: 'productName', label: this.$t('components.productName'), _style: 'width:20%'},
                    {key: 'salesProgram', label: this.$t('salesPlan'), _style: 'width:10%'},
                    {key: 'minQty', label: this.$t('components.productOrderPoint'), _style: 'width:10%'},
                    {key: 'stock', label: this.$t('SaleableQty'), _style: 'width:10%'},
                    // {key: 'color', label: this.$t('buyInWay'), _style: 'width:10%;'},

                    // {key: 'summary', label: this.$t('systemQty'), _style: 'width:20%'},
                    {key: 'onTheWay', label: this.$t('OnTheWay'), _style: 'width:10%;'},
                    {key: 'reqQty', label: this.$t('requested'), _style: 'width:10%;'},
                    {key: 'SystemRequest', label: this.$t('SystemRequest'), _style: 'width:10%;'},
                    {key: 'SystemRequestInput', label: '', _style: 'width:10%;'},
                    {key: 'select', label: '', _style: 'width:10%;'},
                    // {key: 'image', label: this.$t('requested'), _style: 'width:20%;'},
                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

                ],

                table_clicks: 0,
                table_clicks_timer: null,
                details: [],
                place_items: [],
                status_form: 0,
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', true);
                            formData.append('IsWorker', false);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },
                normalizer_place_rows(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },

            }
        }, mounted() {

            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();
            this.get_branches();
            this.$root.root_validate_errors = [];

            this.get_all_data();
            bus.$on('update_orders', (data) => {
                this.get_all_data()
            });

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            'check_all_exit': function () {
                if (this.check_all_exit) {
                    this.id_checkbox_items = [];

                    this.request_product_items.forEach((val) => {
                        this.id_checkbox_items.push(val.productId);
                    });
                } else {
                    this.id_checkbox_items = [];
                }
            },
            '$route.params.person_id': function () {
                // this.get_all_data();
            },
            'start_date': function () {
                this.get_all_data();
            },
            'end_date': function () {
                this.get_all_data();
            }
        },
        methods: {

            get_all_data() {
                this.get_lists_buy();

            },
            insert_data() {

                if (this.id_checkbox_items.length == 0) {
                    this.$root.modal_component.show_validate_errors([this.$t('selectOneProduct')])
                    return false;
                }
                var self = this;

                var master = {
                    MasterCode: "", DeliveryTime: this.get_today(),
                    UserUnitId: 58,
                    RequestFor: 56,
                    PriorityId: 76,
                };

                var sending_products = [];
                self.id_checkbox_items.forEach((val) => {
                    var pp = this.request_product_items.filter(x => x.productId == val)[0];

                    var pro_obj = {
                        MasterId: 0,
                        ProductId: val, Qty: pp.SystemRequestInput,
                        Summary: "",
                        Price: 0, SupplierId: 0
                    };
                    if (pro_obj.SupplierId == null) {
                        pro_obj.SupplierId = 0;
                    }
                    sending_products.push(pro_obj);
                });
                var final_sending = {'master': master, 'details': sending_products};

                const formData = new FormData();
                let url;

                if (this.status_form == 0) {
                    url = "AddPurchaseRequest";
                } else {
                    url = "EditPurchaseRequest";
                    formData.append('Id', this.status_form)

                }

                formData.append('input', JSON.stringify(final_sending));

                axios.post(url, formData, {}).then((res) => {
                    //


                    // self.get_lists();
                    self.$root.modal_component.show_api_response_modals(res);
                    if (res.data.statusCode == 0) {
                        // bus.$emit("update_orders", "");

                        self.add_to_final(res.data.data)

                    } else {
                        // this.$router.push({path:'/dashboard/products/list'})
                        // self.master_id = self.status_form;
                        // self.insert_factor_products();

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });


            },
            add_to_final(ids_list) {
                var self = this;

                const formData = new FormData();
                var url = "AddAcceptPurchaseReq";
                // formData.append("StatusId", 1);
                var ids = [];
                ids_list.forEach(function (val) {
                    ids.push(val.id)
                })
                var obj = {Accepted: ids, ForOuput: []};
                formData.append("input", JSON.stringify(obj));

                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        // this.get_lists_buy();
                        bus.$emit("update_orders", "");

                        self.$root.modal_component.show_api_response_modals(response);
                        self.get_all_data();
                        self.id_checkbox_items = [];
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });


            },

            get_branches() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetPlaces', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.place_items = [];
                        var obj = {label: self.$t('dialogs.choose'), value: 0}
                        self.place_items.push(obj);

                        self.place_items = self.sort_array(
                            self.place_items, content_data.data,
                            'id', 'placeName');

                        // self.selected_branch = self.place_items[0].value

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.selected_factor = item.details;
                    this.selected_master = item;
                    this.show_factor_detail = true;
                    this.table_clicks = 0

                    this.status_form = item.masterId;
                    this.id_checkbox_items = []
                }

            },
            accept_factor() {
                var self = this;


                var details = [];
                var validate = true;
                this.id_checkbox_items.forEach((val) => {
                    var detail = this.selected_factor.filter(x => x.id = val)[0]
                    if (!detail.received_qty || !detail.place) {

                        validate = false
                    }

                    var obj = {
                        SupplierId: this.selected_master.supplierId,
                        OrderMasterId: detail.masterId,
                        OrderDetailId: detail.id,
                        PlaceId: detail.place,
                        ProductId: detail.productId,
                        Qty: detail.received_qty,
                        Price: detail.price,
                        TotalPrice: detail.qty * detail.price,
                        Summary: detail.summary,
                    }
                    details.push(obj)

                });

                if (validate == false) {
                    this.$root.modal_component.show_validate_errors([this.$t('fillAllFields')])
                    return true;
                }
                var model = {Details: details}

                const formData = new FormData();
                var url = "AddPurchaseOrderFactor";
                formData.append("input", JSON.stringify(model));

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        self.get_lists_buy();
                        self.$root.modal_component.show_api_response_modals(response);
                        self.show_factor_detail = false

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });


            },
            get_lists_buy() {
                var self = this;


                const formData = new FormData();
                var url = "GetInventoryReplenishmentRpt";


                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    if (content_data.statusCode == 0) {

                        self.request_product_items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.request_product_items.forEach(function (val) {
                            val.SystemRequest = val.salesProgram + val.minQty - val.stock - val.onTheWay - val.reqQty;
                            if (val.SystemRequest > 0) {
                                val.SystemRequestInput = JSON.parse(JSON.stringify(val.SystemRequest))
                            }
                        })
                        // minQty: 85
                        // onTheWay: 0
                        // productCode: "19111"
                        // productId: 1
                        // productName: "17x24 white news Box"
                        // reqQty: 0
                        // salesProgram: 0
                        // stock: 81

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            goReturnDocument(item) {
                this.$router.push({
                    path: '/dashboard/documents/return/' + item.recId + "/false",
                    params: {passed_data: "salam hamidddd"}
                });
            },
            goShowDocument(item) {

                this.$router.push({path: '/dashboard/documents/show/' + item.recId});
            },
            goPrintDocument(item) {
                bus.$emit("print_confirm", item.recId);


            },
            AddRefer(item) {
                this.submit_refer = item.recId;
            },

            AddAllRefer() {
                this.submit_refer = -1;
                if (this.id_checkbox_items.length == 0) {
                    console.log("validate form is false" + this.validate_errors);
                    this.submit_refer = 0;

                }
            },


        },

    }

</script>
